import { Button } from "@/components/ui/button";
import { ArrowsClockwise, Copy, Eye, EyeSlash, Key } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * API Key panel — generate / show / copy / regenerate / revoke.
 * Pure presentational; parent owns the actual key state and the network calls.
 */
export function ApiKeyPanel({
  apiKey,
  showKey,
  generating,
  onToggleShow,
  onCopy,
  onGenerate,
  onRevoke,
}) {
  const masked = apiKey ? `${apiKey.slice(0, 6)}${"*".repeat(30)}${apiKey.slice(-6)}` : "";

  return (
    <div className="border border-slate-200 rounded-md p-5">
      <div className="flex items-center gap-2 mb-4">
        <Key size={18} className="text-[#002FA7]" />
        <h3 className="font-heading text-sm font-semibold text-slate-900">API Key</h3>
      </div>
      {apiKey ? (
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="flex-1 bg-slate-50 border border-slate-200 rounded px-3 py-2 font-mono text-xs text-slate-700">
              {showKey ? apiKey : masked}
            </div>
            <Button variant="ghost" size="sm" className="h-9" onClick={onToggleShow}>
              {showKey ? <EyeSlash size={16} /> : <Eye size={16} />}
            </Button>
            <Button variant="outline" size="sm" className="h-9" onClick={() => { onCopy(apiKey); toast.success("Copied"); }} data-testid="copy-api-key">
              <Copy size={14} className="mr-1" /> Copy
            </Button>
          </div>
          <div className="flex items-center gap-3">
            <Button variant="outline" size="sm" className="text-xs" onClick={onGenerate} disabled={generating}>
              <ArrowsClockwise size={14} className="mr-1" /> Regenerate
            </Button>
            <Button variant="ghost" size="sm" className="text-xs text-red-500 hover:text-red-700 hover:bg-red-50" onClick={onRevoke}>
              Revoke Key
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-xs text-slate-500 mb-3">Generate an API key to access the reporting API from your systems.</p>
          <Button onClick={onGenerate} disabled={generating} className="bg-[#002FA7] hover:bg-[#00227A] text-white" data-testid="generate-api-key-btn">
            {generating ? "Generating..." : "Generate API Key"}
          </Button>
        </div>
      )}
    </div>
  );
}
